import * as React from "react";
import cx from "classnames";

var NavHeader = function NavHeader(props) {
  var activeStep = props.activeStep,
      onChangeStep = props.onChangeStep,
      isEdit = props.isEdit;
  return /*#__PURE__*/React.createElement("div", {
    className: "nav-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("nav-item", {
      active: activeStep === 1
    }),
    onClick: function onClick() {
      return onChangeStep(1);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nav-number"
  }, "1"), /*#__PURE__*/React.createElement("span", {
    className: "nav-label"
  }, "Informaci\xF3n General")), /*#__PURE__*/React.createElement("div", {
    className: cx("nav-item", {
      active: activeStep === 2
    }),
    onClick: function onClick() {
      return onChangeStep(2);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nav-number"
  }, "2"), /*#__PURE__*/React.createElement("span", {
    className: "nav-label"
  }, "Denunciante")), /*#__PURE__*/React.createElement("div", {
    className: cx("nav-item", {
      active: activeStep === 3
    }),
    onClick: function onClick() {
      return onChangeStep(3);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nav-number"
  }, "3"), /*#__PURE__*/React.createElement("span", {
    className: "nav-label"
  }, "Liquidador")), /*#__PURE__*/React.createElement("div", {
    className: cx("nav-item", {
      active: activeStep === 4 && isEdit,
      disabled: !isEdit
    }),
    style: {
      cursor: isEdit ? "pointer" : "not-allowed",
      color: !isEdit ? "#bbb" : undefined,
      background: !isEdit && activeStep === 4 ? "#eee" : undefined
    },
    onClick: function onClick() {
      return isEdit && onChangeStep(4);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nav-number"
  }, "4"), /*#__PURE__*/React.createElement("span", {
    className: "nav-label"
  }, "Documentos")));
};

export default NavHeader;